
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { PhoneNumberUtil } from 'google-libphonenumber';

export function internationalPhoneValidator(defaultRegion: string = 'US'): ValidatorFn {
  const phoneUtil = PhoneNumberUtil.getInstance();
  return (control: AbstractControl): ValidationErrors | null => {
    const raw = control.value;
    if (!raw) {
      return null; // don’t block empty—use Validators.required separately if you need it
    }
    try {
      // Parse number in given region context
      const number = phoneUtil.parseAndKeepRawInput(raw, defaultRegion);
      // Check both “is possible” and “is valid”:
      if (phoneUtil.isPossibleNumber(number) && phoneUtil.isValidNumber(number)) {
        return null;
      }
      return { internationalPhone: { valid: false, raw } };
    } catch (e) {
      // Thrown if parsing fails
      return { internationalPhone: { valid: false, raw } };
    }
  };
}
